import "./style.css";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IoCopyOutline, AiOutlineCheckCircle } from "react-icons/all";

function DepositInstructionsSR() {
  const [copied, setCopied] = useState(false);
  const copy = () => setCopied(true);
  const [copied1, setCopied1] = useState(false);
  const copy1 = () => setCopied1(true);
  const [copied2, setCopied2] = useState(false);
  const copy2 = () => setCopied2(true);
  const [copied3, setCopied3] = useState(false);
  const copy3 = () => setCopied3(true);

  const data = [
    {
      bank: "BKT",
      nr: "1906565627031134",
      state: copied,
      copyText: copy,
      link: "https://ebank.bkt-ks.com/ebanking/login.html",
      link1: "https://ebank.bkt-ks.com/ebanking-business/login.html",
    },
    {
      bank: "BPB",
      nr: "1300001002074205",
      state: copied1,
      copyText: copy1,
      link: "https://www.banka-ks.com/BPB/Account/Login",
    },
    {
      bank: "NLB",
      nr: "1701001012338968",
      state: copied2,
      copyText: copy2,
      link: "https://nlb.banka-ks.com/Account/Login",
    },
    {
      bank: "BEK",
      nr: "1401000000737379",
      state: copied3,
      copyText: copy3,
      link: "https://ebanking.bekonomike.com/#/login",
    },
  ];
  return (
    <div id="wrapper-page">
      <div className="deposit_container">
        <div className="row">
          <div className="col-12 deposit_text">
            <h4>
              Izdatvanje elektronski novac na svoj Capital Pai nalog na nekoliko
              načina:
            </h4>
            <h4>
              Dopunite računa bez provizije u kancelarijama i agentima IFJB
              Capital-a na preko 160 lokacija širom Kosova. IFJB Capital će
              dodati elektronski novac čim dobije novac od vas. Vaša sredstva su
              sigurna i na raspolaganju vam u bilo kom trenutku i možete ih
              podići kad god želite u bilo kojoj filijali ili agentu IFJB
              Capital-a.
            </h4>
            <h5>
              Da biste dopunili račun, morate imati važeći identifikacioni
              dokument kao što su:
            </h5>
            <ul>
              <li>1. Važeća lična karta, pasoš ili vozačka dozvola</li>
              <li>
                2. Dopunu računa putem bankovnog transfera mogu izvršiti sve
                banke uz navođenje sledećeg opisa:
                <ul>
                  <li>
                    Broj telefona i Ime i prezime (koje imate u aplikaciji)
                  </li>
                  <li>
                    Da bi transfer bio besplatan, razmislite o izboru iste banke
                    kao i banka u kojoj imate račun:
                    <ul className="bankat">
                      {data?.map((item) => (
                        <li>
                          <a
                            href={item.link}
                            rel="noreferrer"
                            target="_blank"
                            style={{ color: "#000", textDecoration: "none" }}
                          >
                            {item.bank}: {item.nr}
                          </a>

                          <CopyToClipboard
                            text={item.nr}
                            onCopy={() => item.copyText()}
                          >
                            {item.state ? (
                              <div className="checked">
                                <AiOutlineCheckCircle
                                  style={{ fontSize: 22 }}
                                />
                                Copied to clipboard
                              </div>
                            ) : (
                              <IoCopyOutline
                                style={{ fontSize: 22, cursor: "pointer" }}
                              />
                            )}
                          </CopyToClipboard>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DepositInstructionsSR;
